import { render, staticRenderFns } from "./ModalCompanyRole.vue?vue&type=template&id=79a16f16"
import script from "./ModalCompanyRole.vue?vue&type=script&lang=js"
export * from "./ModalCompanyRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports